import {
  PublicationQueryPreferencesFragment,
  useGetPublicationsQuery,
} from '@sketch/gql-types'

interface GetCommunityPublicationsProps {
  preferences: Partial<PublicationQueryPreferencesFragment> | null
}

export const useGetCommunityPublications = ({
  preferences,
}: GetCommunityPublicationsProps) => {
  const { sort, identifiers, limit, period, search } = preferences || {}

  const { data, loading, error, fetchMore } = useGetPublicationsQuery({
    variables: {
      sort,
      identifiers,
      limit,
      period,
      search,
    },
  })

  return { data, loading, error, fetchMore }
}
